import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import FileDownload from '@/assets/common/file_download.png';
import {
  RequiredDataGraphList,
  RequiredDataHeaderTitle,
} from '@/constants/refundStatement';
import { useAppSelector } from '@/hooks/useReduxHooks';

type Props = {
  isCashBillGuide?: boolean;
};

function RequiredData({ isCashBillGuide }: Props) {
  const [requireData, setRequireData] = useState({ fileName: '', file: '' });
  const { isAutoPayment } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (isAutoPayment) {
      setRequireData(RequiredDataGraphList[0]);
    } else {
      setRequireData(RequiredDataGraphList[1]);
    }
  }, []);

  const onClickFileDownload = async (file: string, fileName: string) => {
    const downloadLink = document.createElement('a');
    const res = await fetch(file);
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <TableHeader>
        {RequiredDataHeaderTitle.map((item, idx) => (
          <Header key={idx} flex={item.flex}>
            <Title>{item.title}</Title>
          </Header>
        ))}
      </TableHeader>
      <GraphList>
        {isCashBillGuide && (
          <Graph>
            <Column flex={1}>2</Column>
            <Column style={{ justifyContent: 'flex-start' }} flex={15}>
              <RequiredText>[필수]</RequiredText>
              KTP 해외간편결제용 부가세 신고 가이드.pdf
            </Column>
            <Column flex={2.5}>
              <Downalod
                onClick={() =>
                  onClickFileDownload(
                    'https://ktp-image.s3.ap-northeast-2.amazonaws.com/KtpPaymentReport/CashBillGuide/%5BKTP%5D+global_payment_guilde.pdf',
                    'KTP 해외간편결제용 부가세 신고 가이드',
                  )
                }
              >
                다운로드
                <DownloadIcon src={FileDownload} />
              </Downalod>
            </Column>
          </Graph>
        )}
        <Graph $isLast>
          <Column flex={1}>1</Column>
          <Column style={{ justifyContent: 'flex-start' }} flex={15}>
            <RequiredText>[필수]</RequiredText>
            {requireData.fileName}
          </Column>
          <Column flex={2.5}>
            <Downalod
              onClick={() =>
                onClickFileDownload(
                  requireData.file,
                  'KTP 부가세신고 퀵 가이드_의료용역',
                )
              }
            >
              다운로드
              <DownloadIcon src={FileDownload} />
            </Downalod>
          </Column>
        </Graph>
      </GraphList>
    </>
  );
}

const TableHeader = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  background-color: #ffffff;
  border-bottom: 1px solid ${(props) => props.theme.mono[35]};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  color: ${(props) => props.theme.mono[65]};
`;
const Header = styled.div<{ flex: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  position: relative;
  flex: ${(props) => props.flex};
`;
const Title = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;
const GraphList = styled.ul``;
const Graph = styled.li<{ $isLast?: boolean }>`
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.pointColors.white};
  ${({ $isLast }) =>
    $isLast &&
    css`
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    `}
  color: ${(props) => props.theme.mono[80]};
  font-weight: 500;
`;
const Column = styled.div<{ flex: number }>`
  display: flex;
  flex: ${(props) => props.flex};
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
`;
const RequiredText = styled.span`
  margin: 0 5px 0 20px;
  padding: 0 12px;
  color: ${(props) => props.theme.blue[100]};
  font-weight: bold;
`;
const Downalod = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.blue[100]};
  cursor: pointer;
`;
const DownloadIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
  margin: 0 0 3px 4px;
`;
export default RequiredData;
